module.exports = __webpack_public_path__ + "img/map@2x.3c8c0428.png";